import { MainFooter } from "@src/component/home/renewal/main/pc/MainFooter";
import { MainGnb } from "@src/component/home/renewal/main/pc/MainGnb";
import { MainLayout } from "@src/component/home/renewal/main/pc/MainLayout";
import { AboutContents } from "./AboutContents";

const AboutPage = () => (
	<MainLayout>
		<MainGnb type="none" />
		<AboutContents />
		<MainFooter />
	</MainLayout>
);

export default AboutPage;
